import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { dataTableRemoveData } from 'gnos-tables'

function mapStateToProps(state) {
    return {
        height: state.getIn(['ui', 'userProfile', 'content', 'height'], 0),
        locale: state.getIn(['translate', 'locale']),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ dataTableRemoveData }, dispatch)
}

export default (InnerComponent) => {
    @connect(mapStateToProps, mapDispatchToProps)
    class hocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return hocConnect
}
